import * as yup from 'yup';

export interface FormProps {
  accountable: string;
  email: string;
  cellphone: string;
  bank: any;
  agency: string;
  account: string;
  confirmData: boolean;
}

export const schema: yup.SchemaOf<FormProps> = yup.object().shape(
  {
    comments: yup.string(),
    accountable: yup.string().required('Campo Obrigatório'),
    email: yup.string().email('Email inválido').required('Campo Obrigatório'),
    cellphone: yup
      .string()
      .matches(/^(\(\d{2}\) \d{5}-\d{4})$/, 'Número inválido')
      .required('Campo Obrigatório'),
    businessphone: yup
      .string()
      .nullable()
      .notRequired()
      .when('businessphone', {
        is: (value: string) => value?.length,
        then: rule =>
          rule.matches(/^(\(\d{2}\) \d{4}-\d{4})$/, 'Número inválido'),
      }),
    // bank: yup.string().required('Campo Obrigatório'),
    bank: yup.object().shape({
      label: yup.string().required('Campo Obrigatório'),
      value: yup.string().required('Campo Obrigatório'),
      data: yup.object().notRequired(),
    }),
    agency: yup.string().required('Campo Obrigatório'),
    account: yup.string().required('Campo Obrigatório'),
    confirmData: yup.boolean().required().oneOf([true]),
  },
  [['businessphone', 'businessphone']],
);

export const schemaDraft: yup.SchemaOf<any> = yup.object().shape(
  {
    email: yup.string().email('Email inválido').nullable().notRequired(),
    cellphone: yup
      .string()
      .nullable()
      .notRequired()
      .when('cellphone', {
        is: (value: string) => value?.length,
        then: rule =>
          rule.matches(/^(\(\d{2}\) \d{5}-\d{4})$/, 'Número inválido'),
      }),
    businessphone: yup
      .string()
      .nullable()
      .notRequired()
      .when('businessphone', {
        is: (value: string) => value?.length,
        then: rule =>
          rule.matches(/^(\(\d{2}\) \d{4}-\d{4})$/, 'Número inválido'),
      }),
    // bank: yup.string().required('Campo Obrigatório'),
  },
  [
    ['email', 'email'],
    ['cellphone', 'cellphone'],
    ['businessphone', 'businessphone'],
  ],
);
